<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZJ34Ew/tc-custom/9781612005164.jpg?1734580660553" alt="This image is the cover for the book Greek Warriors, Casemate Short History"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Greek Warriors, Casemate Short History
      </h1>
      <p class="bookDescription body article font2">
        <b>A concise, enlightening portrait of the men who fought in the ancient battles we still study today.</b><br/>  <br/> Thermopylae. Marathon. Though fought 2,500 years ago in ancient Greece, the names of these battles are more familiar to many than battles fought in the last half-century. But our concept of the men who fought in these battles may be more a product of Hollywood than Greece.<br/>  <br/> Shaped by the landscape in which they fought, the warriors of ancient Greece were mainly heavy infantry. While Bronze Age Greeks fought as individuals, for personal glory, the soldiers of the classical city-states fought as hoplites, armed with long spears and large shields, in an organized formation called the phalanx.<br/>  <br/> As well as fighting among themselves, as in the notable thirty-year Peloponnesian War between Athens and Sparta immortalized by Thucydides, the city-states came together to fight outside threats. The Persian Wars lasted nearly half a century and saw the Greek armies come together to fend off several massive Persian forces, both on land and at sea.<br/>  <br/> This book sketches the change from heroic to hoplite warfare, and discusses the equipment and training of both the citizen soldiers of most Greek cities and the professional soldiers of Sparta.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Carolyn Willekes
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Casemate Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0a5e0f38